import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { componentJa } from "main/locales/component/ja";
import { componentEn } from "main/locales/component/en";
import { componentKo } from "main/locales/component/ko";
import { componentZhCn } from "main/locales/component/zhCn";
import { componentZhTw } from "main/locales/component/zhTw";
import { constantEn } from "main/locales/constant/en";
import { constantJa } from "main/locales/constant/ja";
import { constantKo } from "main/locales/constant/ko";
import { constantZhCn } from "main/locales/constant/zhCn";
import { constantZhTw } from "main/locales/constant/zhTw";
import { labelEn } from "main/locales/label/en";
import { labelJa } from "main/locales/label/ja";
import { labelKo } from "main/locales/label/ko";
import { labelZhCn } from "main/locales/label/zhCn";
import { labelZhTw } from "main/locales/label/zhTw";
import { buttonEn } from "main/locales/button/en";
import { buttonJa } from "main/locales/button/ja";
import { buttonKo } from "main/locales/button/ko";
import { buttonZhCn } from "main/locales/button/zhCn";
import { buttonZhTw } from "main/locales/button/zhTw";
import { en as unitEn } from "main/locales/unit/en.yml";
import { ja as unitJa } from "main/locales/unit/ja.yml";
import { ko as unitKo } from "main/locales/unit/ko.yml";
import unitZhCn from "main/locales/unit/zh_cn.yml";
import unitZhTw from "main/locales/unit/zh_tw.yml";


import { labelEn as adminLabelEn } from "admin/locales/label/en";
import { labelJa as adminLabelJa } from "admin/locales/label/ja";
import { labelKo as adminLabelKo } from "admin/locales/label/ko";
import { labelZhCn as adminLabelZhCn } from "admin/locales/label/zhCn";
import { labelZhTw as adminLabelZhTw } from "admin/locales/label/zhTw";
import { constantEn as adminConstantEn } from "admin/locales/constant/en";
import { constantJa as adminConstantJa } from "admin/locales/constant/ja";
import { constantKo as adminConstantKo } from "admin/locales/constant/ko";
import { constantZhCn as adminConstantZhCn } from "admin/locales/constant/zhCn";
import { constantZhTw as adminConstantZhTw } from "admin/locales/constant/zhTw";
import { componentJa as adminComponentJa } from "admin/locales/component/ja";
import { componentEn as adminComponentEn } from "admin/locales/component/en";
import { componentKo as adminComponentKo } from "admin/locales/component/ko";
import { componentZhCn as adminComponentZhCn } from "admin/locales/component/zhCn";
import { componentZhTw as adminComponentZhTw } from "admin/locales/component/zhTw";
import { en as adminUnitEn } from "admin/locales/unit/en.yml";
import { ja as adminUnitJa } from "admin/locales/unit/ja.yml";
import { ko as adminUnitKo } from "admin/locales/unit/ko.yml";
import adminUnitZhCn from "admin/locales/unit/zh_cn.yml";
import adminUnitZhTw from "admin/locales/unit/zh_tw.yml";
import { buttonEn as adminButtonEn } from "admin/locales/button/en";
import { buttonJa as adminButtonJa } from "admin/locales/button/ja";
import { buttonKo as adminButtonKo } from "admin/locales/button/ko";
import { buttonZhCn as adminButtonZhCn } from "admin/locales/button/zhCn";
import { buttonZhTw as adminButtonZhTw } from "admin/locales/button/zhTw";

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      component: componentEn,
      constant: constantEn,
      label: labelEn,
      button: buttonEn,
      unit: unitEn['unit'],
      adminLabel: adminLabelEn,
      adminConstant: adminConstantEn,
      adminComponent: adminComponentEn,
      adminUnit: adminUnitEn['adminUnit'],
      adminButton: adminButtonEn,
    },
    ja: {
      component: componentJa,
      constant: constantJa,
      label: labelJa,
      button: buttonJa,
      unit: unitJa['unit'],
      adminLabel: adminLabelJa,
      adminConstant: adminConstantJa,
      adminComponent: adminComponentJa,
      adminUnit: adminUnitJa['adminUnit'],
      adminButton: adminButtonJa,
    },
    ko: {
      component: componentKo,
      constant: constantKo,
      label: labelKo,
      button: buttonKo,
      unit: unitKo['unit'],
      adminLabel: adminLabelKo,
      adminConstant: adminConstantKo,
      adminComponent: adminComponentKo,
      adminUnit: adminUnitKo['adminUnit'],
      adminButton: adminButtonKo,
    },
    "zh_cn": {
      component: componentZhCn,
      constant: constantZhCn,
      label: labelZhCn,
      button: buttonZhCn,
      unit: unitZhCn['zh_cn']['unit'],
      adminLabel: adminLabelZhCn,
      adminConstant: adminConstantZhCn,
      adminComponent: adminComponentZhCn,
      adminUnit: adminUnitZhCn['zh_cn']['adminUnit'],
      adminButton: adminButtonZhCn,
    },
    "zh_tw": {
      component: componentZhTw,
      constant: constantZhTw,
      label: labelZhTw,
      button: buttonZhTw,
      unit: unitZhTw['zh_tw']['unit'],
      adminLabel: adminLabelZhTw,
      adminConstant: adminConstantZhTw,
      adminComponent: adminComponentZhTw,
      adminUnit: adminUnitZhTw['zh_tw']['adminUnit'],
      adminButton: adminButtonZhTw,
    },
  },
  fallbackLng: "ja", // => language to use if translations in user language are not available.
  // lng: "ja", // => language to use (overrides language detection)
  supportedLngs: ["ja", "en", "ko", "zh_cn", "zh_tw"], // => array of allowed languages
  interpolation: {
    escapeValue: false, // not needed for react
  },
  ns: [
    "component",
    "payment",
    "label",
    "unit",
    "validation",
    "adminLabel",
    "adminConstant",
    "adminComponent",
    "adminUnit",
    "adminButton",
    "adminValidation",
  ],
});
export default i18n;
